import React , {useState} from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { cn } from '@/lib/utils';

import { Button, ButtonProps } from '@/components/ui/button';
import { Calendar, CalendarProps } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

interface DatePickerProps extends Omit<ButtonProps, 'onSelect'> {
  selectedDate: Date | null;
  onSelectDate: (date: Date | null) => void;
  buttonText?: string;
  dateFormat?: string;
  calendarProps?: CalendarProps;
  placeholder?: string;
  inline?: boolean;
  calendarPosition?: string;
  dayPickerProps?: object;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  selectedDate,
  onSelectDate,
  buttonText = 'Pick a date',
  dateFormat = 'PPP',
  variant = 'outline',
  className,
  calendarPosition = '',
  inline = false, // Default to false
  dayPickerProps,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const handleSelect = (date: Date | undefined) => {
    onSelectDate(date || null);
    setOpen(false)
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={variant}
          className={cn(
            'w-full justify-between text-left font-normal relative',
            !selectedDate && 'text-muted-foreground',
            className
          )}
          {...rest}
        >
          {selectedDate ? (
            format(selectedDate, dateFormat)
          ) : (
            <span>{buttonText}</span>
          )}
          <CalendarIcon className="mr-2 h-4 w-4" style={{ color: '#FF825C' }} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={cn(
          'absolute   mt-2 w-auto p-0 bg-[#fff]',
          'top-full',
          { 'left-[-140px]': inline },
          calendarPosition
        )}
      >
        <Calendar
          date={selectedDate!}
          setDate={handleSelect}
          {...dayPickerProps}
        />
      </PopoverContent>
    </Popover>
  );
};
